__turbopack_context__.v({
  "container": "all-spreads-overlay-module-scss-module__5w4YkG__container",
  "currentPage": "all-spreads-overlay-module-scss-module__5w4YkG__currentPage",
  "hidden": "all-spreads-overlay-module-scss-module__5w4YkG__hidden",
  "mobileThumbnailTitle": "all-spreads-overlay-module-scss-module__5w4YkG__mobileThumbnailTitle",
  "noImagePlaceholder": "all-spreads-overlay-module-scss-module__5w4YkG__noImagePlaceholder",
  "thumbnailHoverOverlay": "all-spreads-overlay-module-scss-module__5w4YkG__thumbnailHoverOverlay",
  "thumbnailImage": "all-spreads-overlay-module-scss-module__5w4YkG__thumbnailImage",
  "thumbnailImageWrapper": "all-spreads-overlay-module-scss-module__5w4YkG__thumbnailImageWrapper",
  "thumbnailItem": "all-spreads-overlay-module-scss-module__5w4YkG__thumbnailItem",
  "thumbnailTitle": "all-spreads-overlay-module-scss-module__5w4YkG__thumbnailTitle",
  "thumbnailsGrid": "all-spreads-overlay-module-scss-module__5w4YkG__thumbnailsGrid",
});
